import styled from 'styled-components'
//import { Button } from 'veloe-ds'

const blur = `
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(10px);
  pointer-events: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

export const CustomButtom = styled.button`
  min-width: unset !important;
  min-height: unset !important;
  height: 50px !important;
  font-family: 'Work Sans';
  font-weight: 700;
  
  .label {
    position: relative;
    font-family: 'Work Sans';
    font-weight: 700;
    height: auto;
    top: 0 !important;
    line-height: 1;
  }
  ${props => props.blur && blur}
`
